<h2 class="title">
  @if (!categoryTitle) {
    <span>Oferty naszych partnerów</span>
  }
  @if (categoryTitle) {
    <span>Oferty - {{ categoryTitle }}</span>
  }
</h2>
<div class="order-main-holder">
<app-offer-menu  [context]="'offers'" [selectedGroupId]="selectedGroup" (groupSelected)="onGroupSelected($event)"></app-offer-menu>
</div>
@if (groupsLoaded) {
  <app-offer-list [group]="selectedGroup" (loadingComplete)="onLoadingComplete()"></app-offer-list>
}